import Config from "../../models/Config";
import Card from "./Card";

const Grid = (props) => {
    const {colorBg, openMenu, setContentSlideMenu, ConfigVar} = props;

    return <div className="grid grid-cols-3 gap-4">
        {Object.keys(ConfigVar.apps).map((item, i) => {
            const app = ConfigVar.apps[item];
            if(typeof app.link == 'string'){
                return <Card
                title={app.title}
                text={app.description}
                link={app.link}
                colorBg={ConfigVar.color}
                colorText={ConfigVar.colorText}
                image={app.image}
              ></Card>
            }else{
                return <Card
                title={app.title}
                text={app.description}
                link={app.link}
                openMenu={openMenu}
                contentMenu={() => setContentSlideMenu(app.link)}
                colorBg={ConfigVar.color}
                colorText={ConfigVar.colorText}
                image={app.image}
              ></Card>
            }
            
        })}</div>
};

export default Grid;